<div class="packages-search-bar-cont"
  [class.is-flight-results]="isFlightsResult$ | async"
  [class.hotel-detail]="showHotelDetail"
  [class.results]="isResultsPage">
  <ng-container *ngIf="isMobile$ | async; else desktopSearchBar">
    <app-packages-search-bar-mobile
      [searchType]="searchType"
      [source]="source"
      [showHotelDetail]="showHotelDetail"
      [hotelDetail]="hotelDetail"
      [loadDefaultplaces]="loadDefaultplaces"
      (showMobileCalendarEvent)="showMobileCalendarEvent.emit($event)">
    </app-packages-search-bar-mobile>
  </ng-container>
  
  <ng-template #desktopSearchBar>
    <app-packages-search-bar-desktop
      [showHotelDetail]="showHotelDetail"
      [source]="source"
      [hotelDetail]="hotelDetail"
      [searchType]="searchType">
    </app-packages-search-bar-desktop>
  </ng-template>
</div>